export const LEGAL_LINKS = {
  privacyPolicy: 'https://converge.ai/privacy-policy',
  termsOfService: 'https://converge.ai/terms-of-service',
} as const;
